<script>
    import {onDestroy, onMount} from "svelte";
    import {
        buildingStepLogUrl,
        lastBuildRequestUrl,
        newBuildRequestUrl
    } from "../urls";
    import {customFetch} from "../customFetch";
    import Transition from "../components/Transition.svelte";
    import {notifications} from "../notifications";
    import {dateFormatter} from "../dateFormatter";
    import CheckIcon from "../icons/CheckIcon.svelte";
    import Spinner from "../icons/Spinner.svelte";
    import XMarkIcon from "../icons/XMarkIcon.svelte";

    let statusSettings = {
        NEW: {name: "New request", classes: "text-black"},
        PROCESSING: {name: "Processing", classes: "text-orange-600"},
        FAILED: {name: "Failed", classes: "text-red-600"},
        COMPLETED: {name: "Succeed", classes: "text-green-600"},
    };

    const stepStates = {
        0: {name: "Processing", classes: "bg-gray-100"},
        1: {name: "Completed", classes: "bg-green-200"},
        2: {name: "Failed", className: "bg-red-200"},
    };

    let lastBuild;
    let bundlesCount = -1;
    let status;
    let updateIntervalText = "";

    let ticks = -1;
    let interval;
    let log = "";

    async function tick() {
        if (ticks > 0) ticks--;

        if (ticks !== 0) updateIntervalText = "";
        else if (ticks === 0) {
            ticks--;
            updateIntervalText = "Retrieving status...";
            await update();
            ticks = 10;
        }
    }

    async function init() {
        await update();
        ticks = 10;
        interval = setInterval(tick, 1000);
    }

    onMount(init);
    onDestroy(() => clearInterval(interval));

    let data;

    async function update() {
        try {
            let response = await customFetch(lastBuildRequestUrl());

            data = await response.json();
            data.CreatedAt = dateFormatter.format(new Date(data.CreatedAt))
            if (data.Steps) {
                data.Steps = data.Steps.map((item) => {
                    item.CreatedAt = dateFormatter.format(new Date(item.CreatedAt));
                    return item;
                })
            }
        } catch (e) {
            notifications.danger(
                `Error during status retrieving: ${e.message}`
            );
        }
    }

    async function newTask() {
        try {
            await customFetch(newBuildRequestUrl());

            await update();
        } catch (e) {
            notifications.danger(
                `Unable to create new build request: ${e.message}`
            );
        }
    }
</script>

<Transition>
    <div class="content-container">
        {#if data == null || data.Status === "FAILED" || data.Status === "COMPLETED"}
            <button class="btn-primary" on:click={() => newTask(false)}>Rebuild</button>
        {/if}
        {#if data}
            Status: <span class={statusSettings[data.Status].classes}>{statusSettings[data.Status].name}</span>
            <br/>Created at: {data.CreatedAt}
            {#if data.Steps && data.Steps.length > 0}
            <br/>Steps:
            <div class="pl-4">
                <ol class="relative text-gray-500 border-l border-gray-200">
                    {#each data.Steps as row}
                        <li class="mb-6 ml-6">
                            <span
                                class="absolute flex items-center justify-center w-8 h-8 rounded-full -left-4 ring-4 ring-white {stepStates[row.State].classes}">
                                {#if row.State === 0}
                                    <Spinner />
                                    {:else if row.State === 1}
                                    <CheckIcon />
                                    {:else}
                                    <XMarkIcon />
                                    {/if}
                            </span>
                            <h3 class="font-medium leading-tight">{row.Name}</h3>
                            <p class="text-sm">{row.CreatedAt}</p>
                            <p class="text-sm">{row.Status}{#if row.LogSize > 0} <a href={buildingStepLogUrl(row.ID)} target="_blank">log</a>{/if}</p>
                        </li>
                    {/each}
                </ol>
            </div>
            {/if}
        {/if}
    </div>
</Transition>

<style>
    th {
        @apply p-2 border border-slate-400 text-xl
    }

    td {
        @apply p-2 border border-slate-300
    }
</style>